import { jsx as _jsx } from "react/jsx-runtime";
import { JsonView as _JsonView, allExpanded, defaultStyles, } from 'react-json-view-lite';
import cls from './index.module.less';
export const JsonView = ({ data }) => {
    return (_jsx(_JsonView, { data: data, shouldExpandNode: allExpanded, style: {
            ...defaultStyles,
            container: `_GzYRV ${cls.jsonViewContainer}`,
            label: cls.jsonViewLabel,
            nullValue: cls.jsonViewNullValue,
            undefinedValue: cls.jsonViewUndefinedValue,
            stringValue: cls.jsonViewStringValue,
            booleanValue: cls.jsonViewbBooleanValue,
            numberValue: cls.jsonViewbNumberValue,
            otherValue: cls.jsonViewbOtherValue,
            collapseIcon: `${cls.jsonViewbCollapseIcon} _f10Tu _1MFti _1LId0`,
            punctuation: cls.jsonViewbPunctuation,
            expandIcon: `${cls.jsonViewbExpandIcon} _f10Tu _1MFti _1UmXx`,
            collapsedContent: `${cls.jsonViewbCollapsedContent} _1pNG9 _1MFti`,
        } }));
};
